import { ILanguageStrings } from '../utils/languages/languages';

export interface IRequestAccessProps {
  nextStep: Function;
  previousStep: Function;
  handleChange: Function;
  companyKey: string;
  languageStrings: ILanguageStrings;
  data: IRequestAccessState;
}

export interface IRequestAccessState {
  requestAccessReason: string;
  portalId: string;
  contractId: string;
  refPersonKey: string;
  offeringKey: string;
}

export const RequestAccessState: IRequestAccessState = {
  requestAccessReason: '',
  portalId: '',
  contractId: '',
  refPersonKey: '',
  offeringKey: ''
};
